
import React from "react";
import { TableHeader as UITableHeader, TableRow, TableHead } from "@/components/ui/table";
import { isIronTest } from "@/components/level3/scoring/utils";

interface TableHeaderProps {
  isChippingTest?: boolean;
  isSpecialPutts?: boolean;
  isWedgingTest?: boolean;
  isPuttingTest?: boolean;
  isIronTest?: boolean;
  getTableHeadTitle: () => string;
}

const TableHeader: React.FC<TableHeaderProps> = ({
  isChippingTest = false,
  isSpecialPutts = false,
  isWedgingTest = false,
  isPuttingTest = false,
  isIronTest = false,
  getTableHeadTitle
}) => {
  const title = getTableHeadTitle();

  return (
    <UITableHeader>
      <TableRow>
        <TableHead className="w-[100px]">Point</TableHead>
        <TableHead className="w-[120px]">Distance</TableHead>
        {Array.from({ length: 10 }, (_, index) => (
          <TableHead key={index} className="text-center w-[50px]">
            {index + 1}
          </TableHead>
        ))}
        <TableHead className="text-center w-[80px]">Total</TableHead>
      </TableRow>
    </UITableHeader>
  );
};

export default TableHeader;
